import { LtiMember } from "../../lti/shared/lti-member";
import { Submission } from "./submission";
import { SubmissionStatus } from "./submission-status.enum";

export class StudentSubmission {
    user : LtiMember;
    status : SubmissionStatus = SubmissionStatus.NOT_SUBMITTED;
    
    private _submission : Submission;
    set submission(sub : Submission){
        this._submission = sub;
        if(!sub.userSubmissionDate){
            return;
        }

        if(typeof(sub.grade) == 'undefined'){
            this.status = SubmissionStatus.NOT_GRADED;
        }else if(sub.lmsSyncDate){
            this.status = SubmissionStatus.PUBLISHED;
        }else{
            this.status = SubmissionStatus.GRADED;
        }
    }
    get submission() : Submission{
        return this._submission;
    }

    constructor(studentSub : StudentSubmission);
    constructor(user : LtiMember);
    constructor(arg : LtiMember | StudentSubmission){
        if(arg['user'] && arg['submission']){
            this.user = (<StudentSubmission>arg).user;
            this.submission = (<StudentSubmission>arg).submission;
        }else{
            this.user = <LtiMember>arg;
        }
    }
  }
